import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColorPickerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18.003,
	viewBox: "0 0 18 18.003",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6604",
		"data-name": "Path 6604",
		d: "M20.71,5.63,18.37,3.29a1,1,0,0,0-1.41,0L13.84,6.41,12.61,5.2A1,1,0,0,0,11.2,6.61l.72.72L3.15,16.1a.491.491,0,0,0-.15.36V20.5a.5.5,0,0,0,.5.5H7.54a.469.469,0,0,0,.35-.15l8.77-8.77.72.72a1,1,0,0,0,1.41-1.41l-1.22-1.22,3.12-3.12A.99.99,0,0,0,20.71,5.63ZM6.92,19,5,17.08l8.06-8.06,1.92,1.92Z",
		transform: "translate(-3 -2.997)",
		fill: "#323338"
	})
});
export { SvgColorPickerIcon as ReactComponent };
